import { useEffect, useRef, useState } from 'react'

const STORAGE_KEY = 'whats-new-auto-opened-release'

type UseWhatsNewAutoOpenParams = {
  isLoading: boolean
  showNewBadge: boolean
  latestReleaseId?: string
}

type UseWhatsNewAutoOpenResult = {
  open: boolean
  setOpen: (open: boolean) => void
}

const readStoredReleaseId = (): string | null => {
  try {
    return sessionStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

const writeStoredReleaseId = (releaseId: string) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, releaseId)
  } catch {
    /* private mode, etc. */
  }
}

export const useWhatsNewAutoOpen = ({
  isLoading,
  showNewBadge,
  latestReleaseId,
}: UseWhatsNewAutoOpenParams): UseWhatsNewAutoOpenResult => {
  const [open, setOpen] = useState(false)
  const lastHandledReleaseKeyRef = useRef<string | null>(null)
  const releaseKey = latestReleaseId ?? '1'

  useEffect(() => {
    if (isLoading || !showNewBadge) {
      return
    }

    if (lastHandledReleaseKeyRef.current === releaseKey) {
      return
    }

    if (readStoredReleaseId() === releaseKey) {
      lastHandledReleaseKeyRef.current = releaseKey
      return
    }

    lastHandledReleaseKeyRef.current = releaseKey
    writeStoredReleaseId(releaseKey)
    setOpen(true)
  }, [isLoading, showNewBadge, releaseKey])

  return { open, setOpen }
}
